import { FileSpreadsheet, Clock, Sparkles } from "lucide-react";

export function WhyChooseUs() {
  const features = [
    {
      icon: FileSpreadsheet,
      title: "Centralize sua Gestão",
      description:
        "Controle pedidos, finanças, clientes e produtos em um único sistema integrado.",
    },
    {
      icon: Clock,
      title: "Venda Mais com o Catálogo Online",
      description:
        "Receba pré-pedidos automaticamente e profissionalize a experiência de compra do seu cliente.",
    },
    {
      icon: Sparkles,
      title: "Comunicação Automatizada",
      description:
        "Envie notificações via WhatsApp para seus clientes sobre o status dos pedidos, de forma automática.",
    },
  ];

  return (
    <section
      id="why-choose-us"
      className="py-20 px-4 container mx-auto scroll-mt-20"
    >
      <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4">
        DIGA{" "}
        <span className="text-gray-900 dark:text-gray-200 font-black">
          ADEUS
        </span>{" "}
        ÀS PLANILHAS
      </h2>
      <p className="text-white/80 text-center mb-12 text-lg">
        Automatize seu negócio com ferramentas profissionais feitas para você
      </p>
      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white dark:bg-gray-800 p-8 rounded-lg text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-gradient-to-b hover:from-white hover:to-orange-50 dark:hover:from-gray-800 dark:hover:to-gray-700"
          >
            <feature.icon className="w-12 h-12 text-[#EE7B11] mx-auto mb-4" />
            <h3 className="text-gray-900 dark:text-white text-xl font-bold mb-2">
              {feature.title}
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
